import { Injectable } from '@angular/core';
import { WidgetsContainerAbstract } from 'src/app/abstract/widgets/widgets-container.abstract';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { WidgetsFormModel } from 'src/app/models/widgets/widgets-form.model';
import { Logger } from 'src/app/core/logger';
import { WidgetsService } from './widgets.service';
@Injectable({
  providedIn: 'root',
})
export class WidgetsTreeExpandService {
  constructor(
    private logger: Logger,
    private widgetsService: WidgetsService) {
    // Empty
  }

  getLayoutRoot(): WidgetsFormModel {
    return this.widgetsService.getLayoutRoot();
  }

  /**
   * Expand all sections
   *
   * @returns
   */
  public async expandAll(): Promise<void> {
    return this.expand(true, this.getLayoutRoot());
  }

  /**
   * Collapse all sections
   *
   * @param expand
   * @returns
   */
   public async collapseAll(): Promise<void> {
    return this.expand(false, this.getLayoutRoot());
  }

  /**
   * Expand or Collapse sections
   *
   * @param expand if true it will expand all sections
   * @param widget
   * @returns
   */
  private async expand(expand: boolean,widget: WidgetsAbstract): Promise<void> {
    if (widget instanceof WidgetsContainerAbstract) {
      const container = widget as WidgetsContainerAbstract;
      if (!expand) {
        container.isContainerExpanded = false;
      } else {
        container.isContainerExpanded=true;
      }

      container.children.forEach((childWidget) => {
        this.expand(expand, childWidget);
      });
    }
    return;
  }
}
